import { NotificationTypeEnum } from '../../../../shared/NotificationTypes.ts';
import { UINotificationItemViewBase } from './UINotificationItemViewBase.ts';
import { LobbyImage } from '@colonist/types';
import { UIOnlineFriendController } from '../ui_friends/UIOnlineFriendController.ts';
import { UIUtilsFriends } from '../ui_friends/UIUtilsFriends.ts';
export class UICTANotificationView extends UINotificationItemViewBase {
    static getViewData(notificationTypeData) {
        switch(notificationTypeData.type){
            case NotificationTypeEnum.LiveRoomInvite:
                return {
                    text: {
                        key: 'strings:roomPage.userInvitedToRoom',
                        options: {
                            username: notificationTypeData.senderUsername,
                            roomId: notificationTypeData.roomId
                        }
                    },
                    image: notificationTypeData.senderIcon,
                    responseButtons: {
                        acceptButtonAction: ()=>UIOnlineFriendController.respondToFriendRoomInvite(notificationTypeData.roomId, true, notificationTypeData.senderUserId),
                        ignoreButtonAction: ()=>UIOnlineFriendController.respondToFriendRoomInvite(notificationTypeData.roomId, false, notificationTypeData.senderUserId)
                    }
                };
            case NotificationTypeEnum.FriendRequestReceived:
                return {
                    text: {
                        key: 'strings:popups.notification.userSentYouFriendRequest',
                        options: {
                            username: notificationTypeData.username
                        }
                    },
                    image: LobbyImage.Friends,
                    responseButtons: {
                        acceptButtonAction: ()=>{
                            void UIUtilsFriends.friendRequestResponded({
                                username: notificationTypeData.username
                            }, true);
                        },
                        ignoreButtonAction: ()=>{
                            void UIUtilsFriends.friendRequestResponded({
                                username: notificationTypeData.username
                            }, false);
                        }
                    }
                };
        }
    }
    constructor(notificationData, parentContainer){
        super('', notificationData.dateReceived, parentContainer);
        this.viewData = UICTANotificationView.getViewData(notificationData.typeData);
        this.createBaseNotification(notificationData.dateReceived);
        this.createResponseButtons();
        this.setClickActions();
        this.removeContentHoverEffectIfNoClickAction();
    }
}
